import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    margin-top: 32px;
`;
